/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Ermrouter_Page_Usermanagement2Inputs */

const en__ermrouter_page_usermanagement2 = /** @type {(inputs: _Ermrouter_Page_Usermanagement2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Users`)
};

/** @type {(inputs: _Ermrouter_Page_Usermanagement2Inputs) => LocalizedString} */
const de__ermrouter_page_usermanagement2 = en__ermrouter_page_usermanagement2;

/**
* | output |
* | --- |
* | "Users" |
*
* @param {_Ermrouter_Page_Usermanagement2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _ermrouter_page_usermanagement2 = /** @type {((inputs?: _Ermrouter_Page_Usermanagement2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Ermrouter_Page_Usermanagement2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__ermrouter_page_usermanagement2(inputs)
	return de__ermrouter_page_usermanagement2(inputs)
});
export { _ermrouter_page_usermanagement2 as "_ermRouter_page_userManagement" }